  document.addEventListener('DOMContentLoaded', function() {
    
    if (!document.querySelector('.routine_schedule_wrapper')) {
    
      const sections = document.querySelectorAll('[id*="routine_schedule"]');
      const wrapper = document.createElement('div');
      wrapper.className = 'routine_schedule_wrapper';

      if (sections.length > 0) {
        sections[0].parentNode.insertBefore(wrapper, sections[0]);
      }
      sections.forEach(section => {
        wrapper.appendChild(section);
      });
    }
  });



document.addEventListener('DOMContentLoaded', function() {
    const searchIcon = document.querySelector('#search-icon');
    const searchInput = document.querySelector('.search__input');

    searchIcon.addEventListener('click', function(event) {
        event.preventDefault();    
        setTimeout(function() {
            searchInput.focus();
        }, 500);
    });
});


<!-- JavaScript for Dynamic Before and After -->

  $(".slider").on("input change", function(e) {
    const sliderPos = e.target.value;
    $(this).siblings('.foreground-img').css('width', `${sliderPos}%`);
    $(this).siblings('.slider-button').css('left', `calc(${sliderPos}% - 27px)`);
  });
  
  $(".viewing-mode").on("change", function() {
    const selectedMode = $(this).val();
  
    $(".viewing-mode").val(selectedMode);

    $(".container-bf").each(function() {
      const blockId = $(this).data('block-id');
      $(this).toggle(blockId === selectedMode);
    });
  });

  $(document).ready(function() {
    const initialMode = $(".viewing-mode").first().val();
    $(".container-bf").hide();
    $(`.container-bf[data-block-id="${initialMode}"]`).show();
  });





// Code to handle add to cart redirecting to the cart page instead of cart drawer.
// It was not working because of the URL as US got /en-us in the URL.

document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!form.action) return;

    const actionURL = new URL(form.action, window.location.origin);
    const cartActions = ["/cart/add", "/cart/change", "/cart/update", "/cart/clear"];
    const matchingAction = cartActions.find((path) => actionURL.pathname.endsWith(path));

    if (matchingAction) {
        event.preventDefault();
        actionURL.pathname = matchingAction;
        form.action = actionURL.toString();
        form.dispatchEvent(new Event("submit", { bubbles: true }));
    }
});

document.addEventListener("click", (event) => {
    const target = event.target.closest('a[data-ajax-cart-request-button]');
    if (!target || !target.href) return;

    const actionURL = new URL(target.href, window.location.origin);
    const cartActions = ["/cart/add", "/cart/change", "/cart/update", "/cart/clear"];
    const matchingAction = cartActions.find((path) => actionURL.pathname.endsWith(path));

    if (matchingAction) {
        event.preventDefault();
        actionURL.pathname = matchingAction;
        target.href = actionURL.toString();
        target.click();
    }
});




// Read more JS
document.addEventListener("DOMContentLoaded", function () {
  const contentContainer = document.querySelector(".collection-side-bar.lower");

  if (contentContainer) {
    const firstParagraph = contentContainer.querySelector("p:first-of-type");

    if (firstParagraph) {
      // Create hidden content wrapper
      const hiddenContent = document.createElement("div");
      hiddenContent.className = "hidden-content";
      hiddenContent.id = "read-more-content";
      hiddenContent.hidden = true;

      // Move all siblings after the first paragraph into the hidden container
      let sibling = firstParagraph.nextElementSibling;
      while (sibling) {
        const nextSibling = sibling.nextElementSibling;
        hiddenContent.appendChild(sibling);
        sibling = nextSibling;
      }

      contentContainer.appendChild(hiddenContent);

      // Create the Read More button
      const readMoreBtn = document.createElement("button");
      readMoreBtn.textContent = "Read More";
      readMoreBtn.className = "read-more-btn";
      readMoreBtn.setAttribute("aria-expanded", "false");
      readMoreBtn.setAttribute("aria-controls", "read-more-content");

      contentContainer.appendChild(readMoreBtn);

      // Toggle behavior
      readMoreBtn.addEventListener("click", function () {
        const isExpanded = contentContainer.classList.toggle("expanded");

        hiddenContent.hidden = !isExpanded;
        readMoreBtn.setAttribute("aria-expanded", String(isExpanded));
        readMoreBtn.textContent = isExpanded ? "Read Less" : "Read More";
      });
    }
  }
});

/* OLD non WCAG code
document.addEventListener("DOMContentLoaded", function () {
  const contentContainer = document.querySelector(".collection-side-bar.lower");

  if (contentContainer) {
    const firstParagraph = contentContainer.querySelector("p:first-of-type");

    if (firstParagraph) {
      const hiddenContent = document.createElement("div");
      hiddenContent.className = "hidden-content";

      let sibling = firstParagraph.nextElementSibling;
      while (sibling) {
        const nextSibling = sibling.nextElementSibling;
        hiddenContent.appendChild(sibling); // Move each sibling to hidden content
        sibling = nextSibling;
      }

      contentContainer.appendChild(hiddenContent);

      const readMoreBtn = document.createElement("a");
      readMoreBtn.textContent = "Read More";
      readMoreBtn.className = "read-more-btn";
      contentContainer.appendChild(readMoreBtn);

      readMoreBtn.addEventListener("click", function () {
        contentContainer.classList.toggle("expanded");

        if (contentContainer.classList.contains("expanded")) {
          readMoreBtn.textContent = "Read Less";
        } else {
          readMoreBtn.textContent = "Read More";
        }
      });
    }
  }
});
*/
